export default "__VITE_ASSET__0qBPpKfU__"